import React from 'react';
import { TeamDetail } from '../TeamCard/model';
import { StylableProp } from '../../../utils/stylable-prop';
import nuIcon from '../../../assets/Icons/nuIcon.svg';
import { GatsbyImage } from 'gatsby-plugin-image';
import StyleButton from '../../controls/StyleButton';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { gradient } from '../../controls/Gradient';
interface TeamMemberImageProps {
  ImageComponent: TeamDetail;
}

function ImageComponent(props: StylableProp<TeamMemberImageProps>) {
  function FirstNameExtractor() {
    const fullName = props?.ImageComponent?.name;
    const nameParts = fullName?.split(' ');
    if (nameParts?.length >= 2) {
      const firstName = nameParts[0];
      return firstName;
    } else {
      // Handle the case where there might not be a last name
      return fullName;
    }
  }
  return (
    <div>
      <div className="relative mb-4 w-[350px] rounded-xl md:w-[280px]">
        <img src={nuIcon} alt="logo" className="absolute z-20 p-3" />
        {props?.ImageComponent?.bannerphoto ? (
          <GatsbyImage
            image={props.ImageComponent.bannerphoto}
            alt="image"
            className={`rounded-xl ${gradient}`}
          />
        ) : (
          <div className={`h-[300px] w-[350px] rounded-xl md:w-[280px] ${gradient}`} />
        )}

        <div
          className="absolute bottom-0 flex w-[350px] cursor-pointer flex-row items-start justify-between rounded-b-xl bg-blue bg-opacity-10 p-3 py-4 text-sm text-white backdrop-blur-lg md:w-[280px] lg:text-base"
          onClick={() =>
            setTimeout(() => {
              document.getElementById('video')?.scrollIntoView({ behavior: 'smooth' });
            }, 300)
          }
        >
          <span>View Featured Podcast</span>
          <ArrowRightIcon className="h-6 w-6" />
        </div>
      </div>
      {props?.ImageComponent?.signatureImg && (
        <div>
          <GatsbyImage
            image={props.ImageComponent.signatureImg}
            alt="image"
            className="rounded-xl"
          />
        </div>
      )}
      <div>
        <button
          onClick={() =>
            setTimeout(() => {
              document.getElementById('video')?.scrollIntoView({ behavior: 'smooth' });
            }, 300)
          }
          className="z-40 mt-8 w-60 cursor-pointer rounded-full border-2  bg-brand py-3 text-center text-sm font-medium text-white transition duration-300 hover:border-brand hover:bg-white hover:text-brand sm:py-4"
        >
          {`Contact ${FirstNameExtractor()}`}
        </button>
      </div>
    </div>
  );
}

export default ImageComponent;
